import { clearAuthStorage } from "./tokenStorage";

export const logoutUser = () => {
  clearAuthStorage();
  window.location.href = "/signin";
};
